import React, { useContext, useEffect, useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { PersonalData } from "../Candidate Portal/Account Tabs/PersonalData";
import { SummeryDetails } from "../Candidate Portal/Account Tabs/SummeryDetails";
import { Experience } from "../Candidate Portal/Account Tabs/Experience";
import { Education } from "../Candidate Portal/Account Tabs/Education";
import { ProfessionalProfile } from "../Candidate Portal/Account Tabs/ProfessionalProfile";
import { Preferences } from "../Candidate Portal/Account Tabs/Preferences";
import { HighLights } from "../Candidate Portal/Account Tabs/HighLights";
import { DContext } from "../../../../context/Datacontext";
import MandatoryBadge from "../../../blocks/ui/MandatoryBadge";

import { fetchCandidate } from "../../../services/Candidate/Profile/fetchCandidateDetails";
import SuccessPage from "./SuccessPage";
import Loading from "../../Loading";

export const AccountRouter = () => {
    const { BeURL } = useContext(DContext)
    const { page } = useParams();
    const [searchParams] = useSearchParams();
    const { currentUser } = useContext(DContext);
    const [error, setError] = useState("")
    const [candidate, setCandidate] = useState(null)
    const [isResumeParsing, setIsResumeParsing] = useState(false)
    const location = useLocation()

    const candidateId = searchParams.get("candidateId") || candidate?._id;

    const pathname = location.pathname

    useEffect(() => {
        // if (pathname === '/create-candidate') {
        //     setCandidate({
        //         createdBy: currentUser.fullName,
        //         user: currentUser._id

        //     })
        // }
        const createCandidate = () => {
            try {

                setCandidate({
                    createdBy: currentUser.fullName,
                    user: currentUser._id

                })

                // ✅ now candidate has _id
            } catch (error) {
                console.error("Error creating candidate:", error);
                alert("Trouble in connecting to the Server! kindly try again later.");
            }
        }

        if (pathname === '/create-candidate' && currentUser?._id) {
            createCandidate();
        }
    }, [pathname, currentUser])


    const fetchCandidateData = () => fetchCandidate(BeURL, candidateId, setCandidate, setError)

    useEffect(() => {
        if (BeURL && currentUser) {
            fetchCandidateData()
        }
    }, [BeURL])

    const renderPage = () => {
        switch (page) {
            case "skills": return <ProfessionalProfile candidate={candidate} fetchCandidateData={fetchCandidateData} setCandidate={setCandidate} setIsResumeParsing={setIsResumeParsing} isResumeParsing={isResumeParsing} />;
            case "personalInformation": return <PersonalData candidate={candidate} fetchCandidateData={fetchCandidateData} setCandidate={setCandidate} setIsResumeParsing={setIsResumeParsing} isResumeParsing={isResumeParsing} />;
            case "profilesummery": return <SummeryDetails candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            case "education": return <Education candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            case "experience": return <Experience candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            case "highlights": return <HighLights candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            case "preferences": return <Preferences candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            case "success": return <SuccessPage candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            default: return <PersonalData candidate={candidate} fetchCandidateData={fetchCandidateData} />;
        }
    };

    if (!candidate || !BeURL || !currentUser) return <Loading />

    return <div>
        {/* {error && <MandatoryBadge error />} */}
        {renderPage()}
    </div>;
};